export enum SelectedTypeEnum {
    AbrirAutomatico = 'AbrirAutomatico',
    AbrirPagina = 'AbrirPagina',
    AbrirMeusAgendamentoDetalhe = 'AbrirMeusAgendamentoDetalhe',
    AbrirDetalhes = 'AbrirDetalhes',
}

export enum OpenPageType {
    AtivacaoGuiaFuturaListaPage = 'AtivacaoGuiaFuturaListaPage',
    RevalidacaoGuiaListaPage = 'RevalidacaoGuiaListaPage',
    CronicosSelecaoIndexPage = 'CronicosSelecaoIndexPage',
    CronicosAdesaoTermoPage = 'CronicosAdesaoTermoPage',
    CronicosGestaoAltaPage = 'CronicosGestaoAltaPage'
}

export enum OpenDetailsType {
    MeuCadastroPage = 'MeuCadastroPage',
    CadPermissaoDefault = 'CadPermissaoDefault',
    AlterarEnderecoEmailNFEPage = 'AlterarEnderecoEmailNFEPage'
}